<template>
  <div>
    <top-bar />
    <div class="content">
      <div class="container-fluid">
        <div class="text-center mt-2">
          <h1 class="h4 mb-0 text-gray-800">📣 Comunicado Importante</h1>
        </div>
        <hr>
        <div class="card shadow-sm">
          <div class="card-body py-4">
            <h6 class="font-weight-bold mb-1">Disparos de mensagens</h6>
            <div>
              <p class="mb-0">Informamos que a funcionalidade de disparo de mensagens via WhatsApp está, neste momento, <b>temporariamente desativada.</b></p>
              <hr>
              <b>🔍 O que aconteceu?</b>
              <p class="mb-1">O WhatsApp possui mecanismos automáticos para identificar e restringir atividades que possam ser classificadas como envio de spam.</p>
              <p>
                Recentemente, esses mecanismos começaram a bloquear alguns envios realizados por diversas plataformas que automatizam o WhatsApp, o que afetou diretamente a estabilidade e a continuidade dos disparos.
              </p>
            </div>

            <div>
              <b>📌 Sobre a responsabilidade de uso</b>
              <p class="mb-1">
                Reforçamos que sempre deixamos claro que o uso desta funcionalidade é de total responsabilidade do cliente, incluindo a conformidade com as políticas do WhatsApp, práticas de envio, frequência de disparos e qualidade das listas utilizadas.
              </p>
              <p>
                Ainda assim, prezamos pela estabilidade da plataforma e buscamos orientar da melhor forma possível para evitar problemas como bloqueios.
              </p>
            </div>

            <div>
              <b>🛠️ O que estamos fazendo?</b>
              <div>
                <ul>
                  <li>Analisando os motivos específicos dos bloqueios.</li>
                  <li>Estudando a crição de envio consciente para garantir a estabilidade da funcionalidade a longo prazo.</li>
                  <li>Melhorarando mecanismos internos de segurança, reputação e autenticação.</li>
                </ul>
              </div>
            </div>

            <hr>
            <div>
              <b>🙏 Agradecemos sua compreensão</b>
              <p>Sabemos da importância dessa ferramenta e estamos trabalhando para que ela volte a funcionar de uma forma que respeite as diretrizes oficiais da plataforma e ofereça segurança para todos os usuários.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "../components/commons/TopBar";

export default {
  name: 'NotificacoesLebot',
  components: {TopBar},
}
</script>
